export default ['normal', '0.05em', '0.07em', '0.08em']
